(() => {
  'use strict';
  const selector = '[data-io-selly-product-id]';
  let engine;
  let queued = false;
  let attached = false;
  const moneyText = (amount, node) => {
    const span = document.createElement('span');
    span.innerHTML = engine.util.tpl.ToCurrency(amount);
    let text = span.textContent.trim();
    const currency = node.dataset.ioSellyCurrency;
    if (node.dataset.ioSellyCurrencyCode === 'true' && currency && !text.includes(currency)) text += ` ${currency}`;
    return text;
  };
  const reset = (node) => {
    node.classList.remove('io-selly-active');
    delete node.dataset.ioSellyState;
    node.querySelector('.io-selly-prices')?.remove();
  };
  const refresh = () => {
    queued = false;
    if (!engine?.manager?.product || !engine?.util?.tpl) return;
    for (const node of document.querySelectorAll(selector)) {
      try {
        const product = engine.manager.product.FindByID(Number(node.dataset.ioSellyProductId));
        if (!product?.variants?.length) { reset(node); continue; }
        const candidates = product.variants.map((variant) => {
          const base = Math.abs(Number(variant.b_price()));
          const discounted = Math.abs(Number(variant.display_price()));
          const discount = variant.getDiscountable();
          const old = Math.max(base, Math.abs(Number(variant.display_old_price())) || 0);
          return { variant, base, discounted, old, valid: discount && !discount.is_cart };
        }).filter((v) => Number.isFinite(v.base) && v.base > 0 && Number.isFinite(v.discounted) && v.discounted >= 0);
        candidates.sort((a, b) => a.discounted - b.discounted || a.base - b.base);
        const lowest = candidates[0];
        if (!lowest?.valid || lowest.discounted >= lowest.base - 0.004) { reset(node); continue; }
        const varying = candidates.some((v) => Math.abs(v.discounted - lowest.discounted) >= 0.005);
        const oldText = moneyText(lowest.old, node);
        let newText = moneyText(lowest.discounted, node);
        if (varying) newText = node.dataset.ioSellyFrom.replace('__price__', newText);
        const state = `${lowest.variant.id}|${oldText}|${newText}`;
        if (node.dataset.ioSellyState === state && node.querySelector('.io-selly-prices')) continue;
        const container = node.querySelector('.price__container');
        if (!container) continue;
        const prices = document.createElement('div');
        prices.className = 'io-selly-prices';
        const oldLabel = document.createElement('span');
        oldLabel.className = 'visually-hidden';
        oldLabel.textContent = node.dataset.ioSellyRegularLabel;
        const oldPrice = document.createElement('s');
        oldPrice.className = 'price-item price-item--regular io-selly-original';
        oldPrice.textContent = oldText;
        const saleLabel = document.createElement('span');
        saleLabel.className = 'visually-hidden';
        saleLabel.textContent = node.dataset.ioSellySaleLabel;
        const newPrice = document.createElement('span');
        newPrice.className = 'price-item price-item--sale io-selly-final';
        newPrice.textContent = newText;
        prices.append(oldLabel, oldPrice, saleLabel, newPrice);
        node.querySelector('.io-selly-prices')?.remove();
        container.append(prices);
        node.dataset.ioSellyState = state;
        node.classList.add('io-selly-active');
      } catch { reset(node); }
    }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  };
  const connect = (event, getEngine) => {
    try {
      const candidate = getEngine();
      if (!candidate?.event_hub || !candidate?.manager?.product) return;
      engine = candidate;
      for (const name of ['promo_updated', 'update_label', 'select_variant', 'locale_ready', 'currency_ready']) {
        engine.event_hub.ListenTo(name, schedule, true, true);
      }
      schedule();
      setTimeout(schedule, 1500);
      setTimeout(schedule, 5000);
    } catch { engine = undefined; }
  };
  const attach = () => {
    if (attached || !window.tdfEventHub?.ListenToEvent) return attached;
    attached = true;
    window.tdfEventHub.ListenToEvent('jsloaded_nfec', connect, true);
    return true;
  };
  if (!attach()) {
    let attempts = 0;
    const timer = setInterval(() => {
      if (attach() || ++attempts >= 150) clearInterval(timer);
    }, 200);
  }
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  }).observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();
